/**
 * Story 29.2 — the accessible name of a nav control that carries the
 * unread-conversation count ("Chats, 3 unread").
 *
 * Same rule as `waitingLabel`: the number is the REAL count even when the
 * `CountBadge` reads "9+", and the name falls back to the bare label exactly
 * when the badge hides (0, absent, loading, error): `formatCount` is the one
 * rule for both.
 */
import { formatCount } from '@/components/ui/count-badge';

export function unreadLabel(name: string, count: number | null | undefined): string {
  if (formatCount(count) === null) return name;
  return `${name}, ${Math.floor(count as number)} unread`;
}
